import React from 'react';
import { usePropertyLookup } from '@/apps/runtimePropertyHealthScore/hooks/usePropertyLookup';
import RecentPropertyLookups from '@/features/realtimeProperty/components/RecentPropertyLookups';
import { useNavigate } from 'react-router-dom';
import PropertySearch from '@/features/realtimeProperty/components/PropertySearch';

const RuntimeSearchPage: React.FC = () => {
  const navigate = useNavigate();

  const onSelectProperty = (selectedPropertyId: number) => {
    navigate(`property/${selectedPropertyId}`)
  }
  const {
    recentLookups,
    handleSelectProperty,
    handleSelectRecentLookup
  } = usePropertyLookup(onSelectProperty);

  return (
    <div className='flex flex-col gap-4'>
      <PropertySearch onSelect={handleSelectProperty} />

      <RecentPropertyLookups
        recentLookups={recentLookups}
        handleSelectRecentLookup={handleSelectRecentLookup}
      />
    </div>
  );
};

export default RuntimeSearchPage;